// extracted by mini-css-extract-plugin
module.exports = {"makeOrderPage":"style-module--makeOrderPage--3vYAk","makeOrderWrapper":"style-module--makeOrderWrapper--1Blc5"};